export default __webpack_public_path__ + "static/media/Body Bag.1219d3d3.jpg";